import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AgentProfilePage from './pages/AgentProfilePage';
import LocalOperatorsPage from './pages/LocalOperatorsPage';
import BookingPage from './pages/BookingPage';
import DonationPage from './pages/DonationPage';
import UsersExamplePage from './pages/UsersExamplePage';
import AboutPage from './pages/AboutPage';
import ImpactReviewPage from './pages/ImpactReviewPage';
import ExpertisePage from './pages/ExpertisePage';
import PartnerPage from './pages/PartnerPage';
import PartnerApplyPage from './pages/PartnerApplyPage';
import AdminVerificationsPage from './pages/AdminVerificationsPage';
import LoginPage from './pages/LoginPage';
import PartnerLoginPage from './pages/PartnerLoginPage';
import RegisterPage from './pages/RegisterPage';
import ProtectedRoute from './ui/ProtectedRoute';

export default function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        {/* Home is always public */}
        <Route path="/" element={<HomePage />} />

        {/* Public pages */}
        <Route path="/agents" element={<AgentProfilePage />} />
        <Route path="/operators" element={<LocalOperatorsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/impact" element={<ImpactReviewPage />} />
        <Route path="/expertise" element={<ExpertisePage />} />

        {/* Auth pages */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/partner/login" element={<PartnerLoginPage />} />
        <Route path="/partner/apply" element={<ProtectedRoute><PartnerApplyPage /></ProtectedRoute>} />
        <Route path="/partner" element={<PartnerPage />} />

        {/* Protected pages */}
        <Route path="/booking/:packageId" element={<ProtectedRoute><BookingPage /></ProtectedRoute>} />
        <Route path="/donations" element={<ProtectedRoute><DonationPage /></ProtectedRoute>} />
        <Route path="/admin/verifications" element={<ProtectedRoute><AdminVerificationsPage /></ProtectedRoute>} />
        <Route path="/users-example" element={<UsersExamplePage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}


